import { useSuspenseQuery } from '@tanstack/react-query';
import type { GatheringSpot, Marker } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_MARKERS_ALL } from '../queryKeys';

type MarkerWithThumbnail = Marker & Pick<GatheringSpot, 'thumbnail'>;
export const useAdminGetAllMarkers = () => {
  const queryFn = async (): Promise<MarkerWithThumbnail[]> => {
    const res = await fetcher(`/v2/admin/markers`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<
    MarkerWithThumbnail[],
    unknown,
    MarkerWithThumbnail[],
    string[]
  >({
    queryKey: ADMIN_MARKERS_ALL,
    queryFn: queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
